module.exports = __webpack_public_path__ + "static/media/download.ab93dd98.png";